import { useEffect, useRef, useState } from "react";
import "./NewPreviewUI.css";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";

import BackgroundImageController from "./BackgroundImageController";
import { setpreviewObject } from "../../redux/slices/Preview";

const NewNavigatorRightPreviewScreen = ({
  hideResizeOptions,
  hideMeetingDetails,
  useTemplateSelected,
  previewData,
  screenHeight,
  screenWidth,
  targetHeight,
  targetWidth,
}) => {
  const contentRef = useRef(null);
  const previewObj = useSelector((state) => state.preview);
  const [video, setVideo] = useState(false);
  const dispatch = useDispatch();
  const videoRef = useRef(null);
  const [zoomLevel, setZoomLevel] = useState(1);
  const [imageLeft, setImageLeft] = useState(0);
  const [imageRight, setImageRight] = useState(0);
  const [imageTop, setImageTop] = useState(0);
  const [imageBottom, setImageBottom] = useState(0);
  const [displayProperty, setDisplayProperty] = useState("Width");

  const containerHeight = window.innerHeight * 0.8;
  const containerWidth = window.innerHeight;

  const scaleX = containerWidth / targetWidth;
  const scaleY = containerHeight / targetHeight;
  const scale = Math.min(scaleX, scaleY);
  const scaledWidth = targetWidth * scale;
  const scaledHeight = targetHeight * scale;
  const meetingObject = localStorage.getItem("meetingObject");
  let meetingData = JSON.parse(meetingObject);

  useEffect(() => {
    if (!useTemplateSelected) {
      if (previewData.imageUrl) {
        if (
          previewData.imageUrl.toLowerCase().includes(".mp4") ||
          previewData.imageUrl.toLowerCase().includes(".mov") ||
          previewData.imageUrl.toLowerCase().includes(".avi")
        ) {
          setVideo(true);
        }

        const img = new Image();
        img.src = previewData.imageUrl;
        img.onload = () => {
          if (
            img.height < img.width &&
            targetHeight < targetWidth &&
            !previewData.displayProperty
          ) {
            setDisplayProperty("Width");
          } else if (
            img.height < img.width &&
            targetHeight > targetWidth &&
            !previewData.displayProperty
          ) {
            setDisplayProperty("Height");
          } else if (
            img.height > img.width &&
            targetHeight < targetWidth &&
            !previewData.displayProperty
          ) {
            setDisplayProperty("Width");
          } else if (!previewData.displayProperty) {
            setDisplayProperty("Height");
          }
        };
      }
    }
  }, [previewData]);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play();
    }
  }, [videoRef]);

  useEffect(() => {
    dispatch(
      setpreviewObject({
        ...previewData,
        styleLeft: imageLeft,
        styleRight: imageRight,
        styleTop: imageTop,
        styleBottom: imageBottom,
        styleZoom: zoomLevel,
        displayProperty: displayProperty,
      })
    );
  }, [zoomLevel, imageBottom, imageLeft, imageTop, imageRight]);

  return (
    <div
      className="newNavigatorRightPreviewScreenContainer"
      style={{
        alignSelf: "center",
        width: `${targetWidth > targetHeight ? containerWidth : scaledWidth}px`,
        height: `${
          targetHeight > targetWidth ? containerHeight : scaledHeight
        }px`,

        transformOrigin: "center center",
        overflow: "hidden",
      }}
    >
      {!useTemplateSelected ? (
        hideMeetingDetails ? (
          <>
            {previewData.imageUrl ? (
              video ? (
                <div
                  className="fullscreen-video-container"
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    background: `linear-gradient(to top, #2B70B0 0%, #1E1E1E 90%)`,
                  }}
                >
                  <video
                    ref={videoRef}
                    className="fullscreen-video"
                    src={`${previewData.imageUrl}`}
                    autoPlay
                    muted
                    loop
                    style={{ transform: `scale(${zoomLevel})` }}
                  />
                </div>
              ) : (
                <>
                  <img
                    src={previewData.imageUrl}
                    style={{
                      height: `${displayProperty === "Height" ? `100%` : ""}`,
                      width: `${displayProperty === "Width" ? `100%` : ""}`,
                      transform: `scale(${zoomLevel})`,
                      left: `${imageLeft}%`,
                      top: `${imageTop}%`,
                      right: `${imageRight}%`,
                      bottom: `${imageBottom}%`,
                      position: "absolute",
                    }}
                  />
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      background: `linear-gradient(to top, #21211E  40%, ${previewData.primaryColor} 100%)`,
                      pointerEvents: "none",
                      opacity: 0.5,
                    }}
                  ></div>
                </>
              )
            ) : (
              <></>
            )}
          </>
        ) : (
          <>
            <div className="roomcontainerDetails">
              <span
                className="roomname"
                style={{
                  fontSize: "8vh",
                  marginLeft: "-2vh",

                  fontWeight: "500",
                  zIndex: 999,
                  fontFamily: `${previewData.fontStyle}`,
                  color: "white",
                }}
              >
                {meetingData?.name || "Event Name"}
              </span>
              <div
                className="occupancycontainer"
                style={{
                  marginTop: "-5vh",
                  zIndex: 999,
                }}
              >
                <div
                  className="busyslot"
                  style={{
                    marginLeft: "-2vh",
                    marginTop: "5vh",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "baseline",
                  }}
                >
                  <span
                    className="occupancyTime"
                    style={{
                      fontFamily: `${previewData.fontStyle}`,
                      color: "white",
                      fontSize: "4vh",
                    }}
                  >
                    <b className="freeforthedaymanager">
                      By {meetingData?.user || "John Doe"}
                    </b>
                  </span>
                </div>
              </div>
            </div>
            {previewData.imageUrl ? (
              video ? (
                <div
                  className="fullscreen-video-container"
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    background: `linear-gradient(to top, #2B70B0 0%, #1E1E1E 90%)`,
                  }}
                >
                  <video
                    ref={videoRef}
                    className="fullscreen-video"
                    src={`${previewData.imageUrl}`}
                    autoPlay
                    muted
                    loop
                    style={{ transform: `scale(${zoomLevel})` }}
                  />
                </div>
              ) : (
                <>
                  <img
                    src={previewData.imageUrl}
                    style={{
                      height: `${displayProperty === "Height" ? `100%` : ""}`,
                      width: `${displayProperty === "Width" ? `100%` : ""}`,
                      left: `${imageLeft}%`,
                      top: `${imageTop}%`,
                      right: `${imageRight}%`,
                      bottom: `${imageBottom}%`,
                      position: "absolute",
                      transform: `scale(${zoomLevel})`,
                    }}
                  />
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      background: `linear-gradient(to top, #21211E  40%, ${previewData.primaryColor} 100%)`,
                      pointerEvents: "none",
                      opacity: 0.5,
                    }}
                  ></div>
                </>
              )
            ) : (
              <></>
            )}
          </>
        )
      ) : previewObj?.previewTemplateObject?.resultantImage ? (
        <div
          className=""
          style={{
            height: "100%",
            width: "100%",
            objectFit: "cover",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: "2vh",
            position: "relative",
            overflow: "hidden",
          }}
        >
          <img src={previewObj?.previewTemplateObject?.resultantImage} />
        </div>
      ) : (
        <>
          <div
            className=""
            style={{
              height: `${displayProperty === "Height" ? `100%` : ""}`,
              width: `${displayProperty === "Width" ? `100%` : ""}`,
              left: `${imageLeft}%`,
              top: `${imageTop}%`,
              right: `${imageRight}%`,
              bottom: `${imageBottom}%`,
              position: "absolute",
              transform: `scale(${zoomLevel})`,
            }}
          >
            <div
              ref={contentRef}
              //   dangerouslySetInnerHTML={{ __html: renderedHtml }}
              style={{
                willChange: "transform",
              }}
            />
          </div>
        </>
      )}
      {!useTemplateSelected ? (
        <>
          {/* <Time preview={true} /> */}
          <div
            className=""
            style={{
              position: "absolute",
              bottom: "5%",
              right: "5%",
            }}
          >
            {/* <HotelName
              preview={true}
              roomId={
                useTemplateSelected
                  ? previewObj.previewTemplateObject.arguments.roomId
                  : previewData.roomId
              }
            /> */}
          </div>
        </>
      ) : (
        <></>
      )}
      {!useTemplateSelected ? (
        !hideResizeOptions && (
          <BackgroundImageController
            zoomLevel={zoomLevel}
            setzoomLevel={setZoomLevel}
            setimageLeft={setImageLeft}
            imageLeft={imageLeft}
            setimageTop={setImageTop}
            imageTop={imageTop}
            setimageRight={setImageRight}
            imageRight={imageRight}
            setimageBottom={setImageBottom}
            imageBottom={imageBottom}
          />
        )
      ) : (
        <></>
      )}
    </div>
  );
};

export default NewNavigatorRightPreviewScreen;
